import { defineComponent } from "vue";

import { PAGE_NAME } from "./attributes";
import { ApplicationComponent } from "./model";

import {
  ApplicationForm,
  ApplicationCrypto,
  ApplicationResult,
  ApplicationConfirm,
  ApplicationWalletConfirm,
  ApplicationVerification,
} from "@/components/pages/application";
import { RequisitesCryptoResponse } from "@/shared/repository/modules/requisites/repo";

type Component = typeof ApplicationForm | typeof ApplicationCrypto;

export default defineComponent({
  name: PAGE_NAME,
  components: {
    ApplicationForm,
    ApplicationCrypto,
    ApplicationResult,
    ApplicationConfirm,
    ApplicationVerification,
    ApplicationWalletConfirm,
  },
  data() {
    return {
      isResult: false,
      isConfirm: false,
      isConfirmWalletExchange: false,
      isLoading: false,
      isVerification: false,
      component: ApplicationComponent.form,
      requisites: <RequisitesCryptoResponse[]>[],
      userRepo: this.$projectServices.userRepo,
      requisitesRepository: this.$projectServices.requisitesRepository,
    };
  },
  async created(): Promise<void> {
    try {
      this.isLoading = true;

      this.requisites = await this.requisitesRepository.cryptoList(
        this.userRepo.userInfo.id
      );
    } catch (error) {
      console.log(error);
    } finally {
      this.isLoading = false;
    }
  },
  computed: {
    displayedComponent(): Component {
      switch (this.component) {
        case ApplicationComponent.form:
          return ApplicationForm;
        case ApplicationComponent.crypto:
          return ApplicationCrypto;
        default:
          return ApplicationForm;
      }
    },
  },
  methods: {
    closeModal(): void {
      this.isVerification = false;
    },
  },
});
